import React, { createContext, useMemo, useState } from 'react';

import {
    ChatBotWireframeConfig,
    Check24Wireframe,
} from 'types/legacy/wireframe';

import { ContactActions, ContactData } from './types';

export const ContactContext = createContext<ContactData>({
    mainConfig: {},
    transactionId: '',
    check24Wireframe: undefined,
});
export const ContactActionContext = React.createContext<ContactActions>({
    setContactData: () => {},
});

export const ContactProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const [mainConfig, setMainConfig] =
        useState<ChatBotWireframeConfig | undefined>();
    const [transactionId, setTransactionId] = useState('');
    const [check24Wireframe, setCheck24Wireframe] =
        useState<Check24Wireframe | undefined>(undefined);

    const contextValue: ContactData = useMemo(
        () => ({
            transactionId,
            mainConfig,
            check24Wireframe,
        }),
        [transactionId, mainConfig, check24Wireframe]
    );

    const actionMap = useMemo<ContactActions>(
        () => ({
            setContactData(data: ContactData) {
                setMainConfig(data.mainConfig);
                setTransactionId(data.transactionId);
                setCheck24Wireframe(data.check24Wireframe);
            },
        }),
        []
    );

    return (
        <ContactActionContext.Provider value={actionMap}>
            <ContactContext.Provider value={contextValue}>
                {children}
            </ContactContext.Provider>
        </ContactActionContext.Provider>
    );
};
